import { CommissionPlansResponse } from './types/CommissionPlans';
import { MakeCall } from './createMakeCall';

const getCommissionPlans = (makeCall: MakeCall) => (userId: number | 'me') =>
  makeCall<CommissionPlansResponse>(
    'GET',
    `/api/v2/user/${userId}/commission-plans`,
  );
export { getCommissionPlans };
